const zh_cn = {
    logo :  '雄韬',
    about_us : '关于我们',
    user_cases : '成功案例',
    contact_us : '和我们聊一聊',
    services : '与众不同',
    slogan_title : '我们是您专属的IT',
    slogan_button_text : '成功案例',
    contact_us_sec_title : "和我们聊一聊",
    contact_us_sec_summary : '我们都是好的倾听者',
    services_sec_title : '我们与众不同',
    services_sec_fea_expert : '专业团队',
    services_sec_fea_expert_intro : '从软件开发到硬件生产，我们都由我们专业团队亲力亲为',
    services_sec_fea_agile : '敏捷交付',
    services_sec_fea_agile_intro : '以带给顾客最大价值为依归，小步快跑，快速迭代交付解决方案',
    services_sec_fea_worth : '最优方案',
    services_sec_fea_worth_intro : '只选最合适的方案，不选最贵的。把顾客的利益放在第一位',
    services_sec_fea_integration : '软硬结合',
    services_sec_fea_integration_intro : '软硬结合是我们能够量身订制提供最优全面方案的根本',
    services_sec_fea_cust : '量身订制',
    services_sec_fea_cust_intro : '了解顾客的需求，为顾客在现实目标的路上提供客制化的方案',
    services_sec_fea_full : '整体方案',
    services_sec_fea_full_intro : '方案必需是整体的。服务也不是一次性的。我们就是您专属的IT部门',
    footer_sec_partner_title : '合作伙伴',
    footer_sec_partner_1 : '卓联智造',
}

export default zh_cn;


// WEBPACK FOOTER //
// ./src/zh_cn.js